module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "security-wall.788bd489.svg";